"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgBellOff = function SvgBellOff(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M13.707 12.293l22 22a1 1 0 01-1.414 1.414L28.585 30H14c-1.333 0-1.333-2 0-2a2 2 0 002-2v-4.999a8 8 0 01.581-3.004l-4.288-4.29a1 1 0 011.414-1.414zm12.525 19.842a1 1 0 01.363 1.367 3 3 0 01-5.19 0 1 1 0 011.666-1.101l.064.097a1 1 0 001.73 0 1 1 0 011.367-.363zM26.585 28l-8.418-8.416A6.006 6.006 0 0018 21v5c0 .729-.195 1.412-.535 2h9.12zm1.45-13.91A8 8 0 0132 21v4a1 1 0 01-2 0v-4a6 6 0 00-8.949-5.23 1 1 0 01-.982-1.74 8 8 0 017.967.06z",
    id: "bell-off_svg__a"
  }));
};

var _default = SvgBellOff;
exports["default"] = _default;